<template>
  <div class="package">
    <HeaderComponent/>
    <Payments/>
    <FooterComponent/>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderPayment';
import Payments from '@/components/PaymentOptions.vue';
import FooterComponent from '@/components/Footer.vue';

export default {
  name: 'Payment',
  components: {
    HeaderComponent,
    Payments,
    FooterComponent,
  }
}
</script>
